import { Link, routes } from '@redwoodjs/router'
import { Toaster } from '@redwoodjs/web/toast'

type FreeWeightLayoutProps = {
  children: React.ReactNode
}

const FreeWeightsLayout = ({ children }: FreeWeightLayoutProps) => {
  return (
    <div className="rw-scaffold">
      <Toaster />
      <header className="rw-header">
        <h1 className="rw-heading rw-heading-primary">
          <Link
            to={routes.freeWeights()}
            className="rw-link"
          >
            FreeWeights
          </Link>
        </h1>
        <Link
          to={routes.newFreeWeight()}
          className="rw-button rw-button-green"
        >
          <div className="rw-button-icon">+</div> New FreeWeight
        </Link>
      </header>
      <main className="rw-main">{children}</main>
    </div>
  )
}

export default FreeWeightsLayout
